/** Longest-prefix match that does not treat `/data` as a prefix of `/data-explorer`. */

export function matchPath(pathname: string, prefix: string): number {
  if (prefix === '/' || prefix.length === 0) return 0
  if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return prefix.length
  return 0
}
